<template>
    <div class="rotator" v-scroll="handleScroll" ref="rotator">
        <div class="rotator-content" ref="content">
            <div class="rotator-item">
                <div class="rotator-text" ref="text">
                    <slot>
                        <!-- content -->
                    </slot>
                </div>
                <div class="rotator-images" >
                    <div class="rotator-images-container">
                         <canvas ref="canvas" width="990" height="990"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import './rotator.sass';

export default {
    props: {
       path: null,
       data: null,
    },
    data() {
        return {
            filterJson: this.data,
            active: null,
            step: 85,
            height: 0,
            images: [],
            offsetTop: 0,
            ctx: null,
        }
    },
    methods: {
        handleScroll() {
            const top = this.offsetTop;
            const textVisible = this.$refs.text.classList.contains('visible');

            if (!textVisible && window.scrollY > top - (4 * this.step) ) {
               this.$refs.text.classList.add('visible');
            }

            if (this.images.length && window.scrollY > top) {
                let id = Math.floor((window.scrollY - top)/this.step);
                if (id >= this.filterJson.length) {
                    id = this.filterJson.length - 1;
                }

                if (this.active != id) {
                    this.active = id;
                    let item = this.images.find(item => {return item.id == id});
                    this.drawImageScaled(item.elem);
                    this.$emit('getCurrentSlide', { active: this.active });
                }        
            }

            if (this.images.length && window.scrollY < top && 0 !== this.active) {
                this.active = 0;
                let item = this.images.find(item => {return item.id == 0});
                this.drawImageScaled(item.elem);
                this.$emit('getCurrentSlide', { active: this.active });
            }     
        },
        async preloadItem(item, index) {
            await new Promise(resolve => {
                let img = new Image();
                img.src = `/img/${this.path}/${item.file}`;
                img.onload = () => {  
                    this.images.push({id: index, elem: img});
                    resolve(img);
                }
            });    
        },
        async preloadItems() {
            const promises = [];
            this.filterJson.forEach((item, index) => {
                const promise = this.preloadItem(item, index);
                promises.push( promise );
            });
            await Promise.all( promises );
        },
        drawImageScaled(img) {
            setTimeout(() => {
                const canvas = this.ctx.canvas;
                const ratio  = Math.min(canvas.width/img.width, canvas.height/img.height);
            
                var shiftX = Math.floor(( canvas.width - img.width * ratio ) / 2);
                var shiftY = Math.floor(( canvas.height - img.height * ratio ) / 2);  
            
                this.ctx.clearRect(0, 0, canvas.width, canvas.height);
                this.ctx.drawImage(img, 0, 0, img.width, img.height, shiftX, shiftY, img.width * ratio, img.height * ratio); 
            })
        }
    },
    async mounted() {
        this.$nextTick(() => {
            if (this.$refs.rotator) {
                const height = this.step * this.filterJson.length + this.$refs.content.offsetHeight;
                this.$refs.rotator.style.height = height + 'px';
                let elem = this.$refs.rotator;   
                this.offsetTop = elem.offsetTop;

                elem = this.$refs.canvas;
                this.ctx = elem.getContext('2d');
                this.$emit('rotatorHeight', { height });
            }
        });

        await this.preloadItems();
        this.handleScroll();
    }
}
</script>